import { addDoc, collection } from "firebase/firestore";
import React, { useRef, useState } from "react";
import Alert from "react-bootstrap/Alert";
import { db } from "../../firebase";

// Firebase Storage isn't available on this project's billing plan, so the
// resume is embedded directly in the Firestore document instead. Firestore
// caps a document at 1MB total, and base64 inflates a file by ~33%, so the
// raw file is capped well below that to leave headroom for the other fields.
const MAX_RESUME_BYTES = 700 * 1024;

const Result = () => {
  return (
    <Alert variant="success" className="success-msg">
      Your Message has been successfully sent.
    </Alert>
  );
};

const FormCareer = () => {
  const form = useRef();

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    resume: "",
    resumeFileName: "",
    resumeFileType: "",
  });
  const [result, showresult] = useState(false);
  const [loading, setLoading] = useState(false);
  const [obj, setObj] = useState();
  const [uploadError, setUploadError] = useState("");
  const [mobileError, setMobileError] = useState("");

  const handleMobileChange = (e) => {
    // Allow only numeric digits and limit to max 10 characters
    const val = e.target.value.replace(/[^\d]/g, "").slice(0, 10);
    setFormData((prev) => ({ ...prev, mobile: val }));
    if (val && val.length !== 10) {
      setMobileError("Contact number must be exactly 10 digits.");
    } else {
      setMobileError("");
    }
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    if (formData.mobile.length !== 10) {
      setMobileError("Please enter a valid 10-digit contact number.");
      return;
    }

    if (!formData.resume) {
      setUploadError("Please attach your CV before submitting.");
      return;
    }

    const ref = collection(db, "applications");
    await addDoc(ref, {
      ...formData,
      submittedAt: new Date().toISOString(),
    });
    setFormData({
      name: "",
      mobile: "",
      email: "",
      resume: "",
      resumeFileName: "",
      resumeFileType: "",
    });
    setObj();
    setUploadError("");
    setMobileError("");
    showresult(true);
  };

  setTimeout(() => {
    showresult(false);
  }, 10000);

  const uploadResume = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > MAX_RESUME_BYTES) {
      setUploadError(
        `"${file.name}" is ${(file.size / 1024).toFixed(0)}KB, which is over the ${(MAX_RESUME_BYTES / 1024).toFixed(0)}KB limit. Please attach a smaller file (a plain PDF or DOCX export usually fits).`
      );
      e.target.value = "";
      setObj();
      setFormData((prev) => ({ ...prev, resume: "", resumeFileName: "", resumeFileType: "" }));
      return;
    }

    setLoading(true);
    setUploadError("");

    const reader = new FileReader();
    reader.onload = () => {
      setFormData((prev) => ({
        ...prev,
        resume: reader.result, // data URI: "data:<mime>;base64,...."
        resumeFileName: file.name,
        resumeFileType: file.type,
      }));
      setObj(file.name);
      setLoading(false);
    };
    reader.onerror = () => {
      console.error("File read error:", reader.error);
      setLoading(false);
      setUploadError("Couldn't read that file. Please try again.");
      e.target.value = "";
    };
    reader.readAsDataURL(file);
  };

  return (
    <form ref={form} onSubmit={sendEmail} className="axil-contact-form">
      <div className="form-group">
        <label>Name</label>
        <input
          type="text"
          className="form-control"
          name="contact-name"
          required
          value={formData.name}
          onChange={(e) => {
            setFormData({ ...formData, name: e.target.value });
          }}
        />
      </div>
      <div className="form-group">
        <label>Email</label>
        <input
          type="email"
          className="form-control"
          name="contact-email"
          required
          value={formData.email}
          onChange={(e) => {
            setFormData({ ...formData, email: e.target.value });
          }}
        />
      </div>
      <div className="form-group">
        <label>Contact No.</label>
        <input
          type="tel"
          className="form-control"
          name="contact-phone"
          required
          maxLength={10}
          placeholder="Enter 10-digit contact number"
          value={formData.mobile}
          onChange={handleMobileChange}
        />
        {mobileError && <div className="text-danger small mt-1">{mobileError}</div>}
      </div>
      <div className="form-group mb--40">
        <label>Drop your CV <span className="text-muted small">(PDF/DOCX, max 700KB)</span></label>
        <div className="fileUpload">
          <input
            type="file"
            className="form-control fileUpload-inp"
            name="contact-file"
            accept=".pdf,.doc,.docx"
            required
            onChange={(e) => uploadResume(e)}
          />
          <div className="fileUpload-mes">
            Drag & Drop Files Here
            <span>&nbsp;Browse Files</span>
          </div>
        </div>
        {obj && <p className="text-success mt-2">{obj} file uploaded</p>}
        {uploadError && <Alert variant="danger" className="mt-2">{uploadError}</Alert>}
      </div>
      <p className="small text-muted mb-3">
        By submitting, you agree to our{" "}
        <a href={process.env.PUBLIC_URL + "/privacy-policy"}>Privacy Policy</a>.
      </p>
      <div className="form-group">
        <button
          type="submit"
          className="axil-btn btn-fill-primary btn-fluid btn-primary"
          name="submit-btn"
          disabled={loading}
        >
          {loading ? "Please wait..." : "Submit"}
        </button>
      </div>

      <div className="form-group">{result ? <Result /> : null}</div>
    </form>
  );
};

export default FormCareer;
